<template>
	<a-modal dialogClass="pay-dialog" :footer="null" :closable="false" :visible="visible"
		@cancel="handleClose">
		<div class="line"></div>
		<div class="main">
			<div class="container">
				<div class="row">
					<div class="col-sm-12 col-md-12 col-lg-12">
						<div class="right">
							<div class="title">
								<a-icon type="wechat" theme="filled" style="font-size: 22px;color: #09BB07;margin-right: 6px;" />
								微信扫码支付
							</div>
							<div class="ewm">
								<div class="img">
									<img :src="currentOrder.ewm" v-if="currentOrder.ewm" />
									<a-spin v-else />
								</div>
							</div>
							<div class="attr">
								<div class="label">订单号：</div>
								<div class="value">{{ currentOrder.no }}</div>
							</div>
							<div class="attr">
								<div class="label">说明：</div>
								<div class="value">{{ currentOrder.desc }}</div>
							</div>
							<div class="attr">
								<div class="label">支付金额：</div>
								<div class="value price">¥{{ currentOrder.price }}</div>
							</div>
							<div class="btn" @click="handleClose">
								<a-icon type="reload" style="font-size: 16px;color: #fff;margin-right: 6px;" />
								我已支付
							</div>
							<div class="tip">支付即代表您已阅读并同意<span>购买协议</span></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</a-modal>
</template>
<script>
import { getDemoQrcodeApi, getDemoStatusApi } from '@/api/soft'

export default {
	name: 'PayDialog',
	computed: {
		isToken() {
			return this.$store.state.token
		},
		userInfo() {
			return this.$store.state.userInfo
		},
	},
	data() {
		return {
			visible: false,
			currentId: '',
			currentOrder: {
				no: '',
				ewm: '',
				desc: '可运行Domo(生成后请在24小时内下载)',
				price: '20',
			},
			payTimer: null
		}
	},
	methods: {
		// 弹窗 打开
		handleOpen(id) {
			this.currentId	= id
			this.visible = true
			this.handlePay()
		},
		// 弹窗 关闭
		handleClose() {
			this.getInfo()
			clearTimeout(this.payTimer)
			this.$emit('completed')
			this.visible = false
		},
		// 套餐 购买
		async handlePay() {
			const res = await getDemoQrcodeApi({
				order_id: this.currentId
			})
			if (res.code == 0) {
				this.currentOrder.no = res.data.out_trade_no
				this.currentOrder.ewm = res.data.images_base64
				this.payTimer = setTimeout(() => {
					this.getPayStatus()
				}, 5000)
			}
		},
		// 套餐 支付状态
		async getPayStatus() {
			clearTimeout(this.payTimer)
			const res = await getDemoStatusApi({
				out_trade_no: this.currentOrder.no
			})
			if (res.code == '0') {
				if (res.data.is_pay) {
					this.$message.success('支付成功')
					this.handleClose()
				} else {
					this.payTimer = setTimeout(() => {
						this.getPayStatus()
					}, 5000)
				}
			} else {
				this.$message.error('支付失败，请重新支付')
			}
		},
		// 获取 用户信息
		getInfo() {
			this.$store
				.dispatch('GetInfo')
				.then(() => {
					// console.log('获取用户信息成功')
				})
				.catch(() => {
					// console.error('获取用户信息失败')
				})
		},
	},
}
</script>
<style lang="scss" scoped>
:deep .pay-dialog {

	.ant-modal-content {
		border-radius: 0;
	}

	.ant-modal-body {
		padding: 0;


		&>.line {
			width: 100%;
			height: 4px;
			background: linear-gradient(90deg, #7845ff, #ff4372);
		}

		&>.main {
			padding: 20px 10px 10px;
			background: linear-gradient(180deg, #E2E5FF 0%, #FFFFFF 100%);
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

			.right {
				height: 100%;
				padding: 20px;
				background: #FFFFFF;
				box-shadow: 0px 2px 24px 0px rgba(0, 0, 0, 0.06);
				border-radius: 18px;
				border: 1px solid #EBEBEB;

				&>.title {
					display: flex;
					align-items: center;
					font-size: 16px;
					color: #333333;
				}

				&>.ewm {
					display: flex;
					justify-content: center;
					align-items: center;
					margin: 50px 0;

					.img {
						display: flex;
						justify-content: center;
						align-items: center;
						width: 172px;
						height: 172px;
						border: 1px solid #5B66FF;
					}

					img {
						width: 170px;
						height: 170px;
					}
				}

				&>.attr {
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-bottom: 8px;
					font-size: 14px;
					color: #333333;

					.price {
						color: #FF3333;
					}
				}

				&>.btn {
					display: flex;
					justify-content: center;
					align-items: center;
					margin: 30px 0 10px;
					width: 100%;
					height: 40px;
					background-color: #5B66FF;
					font-size: 16px;
					color: #fff;
					border-radius: 6px;
				}

				&>.tip {
					font-size: 12px;
					text-align: center;
					color: #999999;

					span {
						text-decoration: underline;
					}
				}
			}
		}
	}
}
</style>
